/* eslint-disable space-before-function-paren */
<template>
  <div>
    <q-layout view="hHh LpR fFf">
      <q-header elevated class="bg-accent text-white">
        <TopBar />
      </q-header>
      <q-page-container>
        <div id="wrapper" class="full-width full-height">
          <RegistroExterno />
        </div>
      </q-page-container>
    </q-layout>
  </div>
</template>
<script>
import TopBar from '@/shared/top-bar/components/TopBar.vue';

import RegistroExterno from '@/components/Usuarios/components/Registro_Externo.vue';
import { QLayout, QHeader, QPageContainer } from 'quasar';
import '@/components/Usuarios/assets/css/css_usuario_vue.css';

export default {
  components: {
    TopBar,
    RegistroExterno,
    QLayout,
    QHeader,
    QPageContainer
  }
};
</script>

<style lang="scss" scoped>
.logo {
  img {
    margin-top: 10px;
    max-width: 135px;
    padding: 0px 0 0 0;
    height: 35px;
    align-items: center;
  }
  i {
    padding: 18px 2% 0 5%;
  }
}
</style>
